export const ALL_USERS = 'ALL_USERS';
export const CLEAR_SELECTED_USER = "CLEAR_SELECTED_USER";
export const SELECTED_USER = "SELECTED_USER";

